<template>
  <div class="pagination">

    <div class="go-to"><input type="number" placeholder="Go to page..." v-model="goToPage" style="display:none"></div>

    <div class="buttons">
      <div :class="pageNumber === 1 ? 'button disabled' : 'button'" @click="emitPageNumberChange(1)">
        <a-icon type="double-left"/>
      </div>
      <div :class="pageNumber === 1 ? 'button disabled' : 'button'" @click="handlePreviousPageNumber">
        <a-icon type="left"/>
      </div>
      <div v-for="page in pageArray" :key="page"
        @click="emitPageNumberChange(page)"
        :class="page === pageNumber? 'page selected' : 'page'"
      >
        {{page}}
      </div>
      <div :class="pageNumber === pageCount ? 'button disabled' : 'button'" @click="handleNextPageNumber">
        <a-icon type="right"/>
      </div>
      <div :class="pageNumber === pageCount ? 'button disabled' : 'button'"  @click="emitPageNumberChange(pageCount)">
        <a-icon type="double-right"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageCount: Number,
    pageNumber: Number
  },
  data () {
    return {
      goToPage: ''
    }
  },
  computed: {
    pageArray () {
      let array = [];
      for (let i = 1; i <= this.pageCount; i++) {
        if(array.length === 5) {
          break;
        }

        if (this.pageNumber < 3) {
          array.push(i)

        }else if (this.pageNumber > this.pageCount - 2) {
          if (i >= this.pageCount - 4) {
            array.push(i)
          }

        }else {
          if (i >= this.pageNumber-2) {
            array.push(i)
          }
        }
      }

      return array;
    }
  },
  methods: {
    handlePreviousPageNumber () {
      if (this.pageNumber === 1) {
        return
      } else {
        this.emitPageNumberChange(this.pageNumber - 1)
      }
    },
    handleNextPageNumber () {
      if (this.pageNumber === this.pageCount) {
        return
      } else {
        this.emitPageNumberChange(this.pageNumber + 1)
      }
    },
    emitPageNumberChange (number) {
      if (this.pageNumber !== number) {
        this.$emit('page-change', number)
      }
    }
  },
  watch: {
    goToPage: {
      handler (newVal) {
        if(this.searchTimeout) {
          clearInterval(this.searchTimeout);
          this.searchTimeout = null;
        }

        newVal = parseInt(newVal)

        if (Number.isNaN(newVal)) {
          return;
        }

        if (newVal > this.pageCount) {
          this.goToPage = this.pageCount;
        } else if (newVal < 1) {
          this.goToPage = 1;
        }

        this.searchTimeout = setTimeout(() => {
          this.emitPageNumberChange(parseInt(this.goToPage));
          this.searchTimeout = null;
        }, 500)
      }
    },
    pageCount: {
      handler () {
        this.goToPage = '';
      }
    },
    pageNumber: {
      handler () {
        this.goToPage = '';
      }
    }
  }
}
</script>

<style scoped lang="scss">
  * {
    user-select: none;
    box-sizing: border-box;
    outline: none;
  }
  .pagination {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #F9F9F9;
    width: 100%;
  }
  .buttons {
    display: flex;
    flex-direction: row;
    width: 50%;
    justify-content: flex-end;
    align-items: center;

  }
  .go-to {
    display: flex;
    justify-content: center;
    width: 30%;
  }
  .page, .button {
    /* display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    cursor: pointer; */
    width: 32px;
    height: 32px;
    padding: 5px 6px;
    border-radius: 2px;
    background: white;
    border: 1px solid white;
    color: #001529;
    line-height: 22px;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Roboto',sans-serif;
    margin-right: 8px;
    cursor: pointer;
    text-align: center;
  }

  .button:last-child{
    margin-right: 0;
  }

  .button.disabled{
    background: transparent;
    cursor: not-allowed;
    border: 1px solid transparent;
    color: #B2BAC7;
  }
  
  .selected {
    /* background-color: #C1C1C1;
    font-weight: 600;
    font-size: 1.1em;
    color: white; */
    width: 32px;
    height: 32px;
    padding: 5px 6px;
    border-radius: 2px;
    background: white;
    border: 1px solid #2295D6;
    color: #2295D6;
    line-height: 22px;
    font-size: 14px;
    font-weight: 900;
    font-family: 'Roboto',sans-serif;
  }
  /* .button {
    font-size: 0.8em;
    width: 15%;
    img {
      max-width: 12px;
      max-height: 12px;
    }
    &.prev {
      img {
        transform: rotate(90deg);
      }
    }
    &.next {
      img {
        transform: rotate(270deg);
      }
    }
  } */

  @media (max-width: 950px) {
    .buttons {
      width: 70%;
    }
  }

  @media (max-width: 700px) {
    .pagination {
      flex-direction: column;
      max-width: 90% !important;
    }
    .buttons {
      width: 100%;
      justify-content: center;
    }
    .go-to {
      justify-content: center;
      width: 100%;
      margin-bottom: 2%;
    }
    .go-to input {
      width: 50%;
    }
  }
</style>